module.exports = __webpack_public_path__ + "hero.png?504ae99a04af7467869c93a05fcc0dd6";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/hero.png
// module id = 334
// module chunks = 0